export default __webpack_public_path__ + "static/media/funded.497bd358.png";